import { render, staticRenderFns } from "./settings-lists-ordertypes.vue?vue&type=template&id=24f294c7&"
import script from "./settings-lists-ordertypes.ts?vue&type=script&lang=ts&"
export * from "./settings-lists-ordertypes.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports